'use client';

import type { ReactElement } from 'react';
import Link from 'next/link';
import { chain } from '@/lib/constants/config';
import { BnbIcon } from '@/assets/logo/bnb';

export default function Based(): ReactElement {
  return (
    <div className="w-fit flex items-center justify-center gap-1.5">
      <p className="font-light text-sm opacity-90">Based on</p>
      <Link
        href="https://www.bnbchain.org"
        target="_blank"
        className="w-fit opacity-90 cursor-pointer hover:opacity-100 transition-all flex flex-row items-center justify-center gap-1"
      >
        <BnbIcon className="w-8 h-8" />
        <p className="font-light text-sm">{chain.name}</p>
      </Link>
    </div>
  );
}
